import router from '@/router';
import { signOut } from './firebaseAuth';
import { authError } from './notification';

export async function handleAuthorizationError() {
  authError();
  await signOut();
  router.push('/login');
}
